import React from 'react'

const FormComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default FormComponent
